import { render, staticRenderFns } from "./SuspenderImpedimento.vue?vue&type=template&id=ae9b1ca0"
import script from "./SuspenderImpedimento.vue?vue&type=script&lang=ts"
export * from "./SuspenderImpedimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports